import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { motion } from 'framer-motion';
import ProductCard from './ProductCard';

const ProductDetail = ({ allProducts }) => {
  const { id } = useParams();
  const history = useHistory();
  const [copied, setCopied] = useState(false);

  const product = allProducts.find(p => p.id === id);
  const [heroImg, setHeroImg] = useState(null);

  useEffect(() => {
    if (product) {
        let img = product.image || (product.originalData ? product.originalData.image_url : null);
        if(img && img.startsWith('http://')) img = `https://wsrv.nl/?url=${encodeURIComponent(img)}&output=png`;
        setHeroImg(img);
    }
  }, [product]);

  const handleHeroError = () => {
    if (heroImg && !heroImg.includes('wsrv.nl')) {
      setHeroImg(`https://wsrv.nl/?url=${encodeURIComponent(product.image)}&output=png&w=600`);
    }
  };

  if (!product) {
    return (
      <div className="detail-loading">
        <h2>PRODUCT NOT FOUND</h2>
        <button className="back-btn-large" onClick={() => history.push('/')}>RETURN HOME</button>
      </div>
    );
  }

  const raw = product.originalData || {};
  const relatedProducts = allProducts.filter(p => 
    p.titleId === product.titleId && p.originalData.region === raw.region && p.id !== product.id
  );

  const handleCopy = () => {
    navigator.clipboard.writeText(product.sku);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <motion.div 
      initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
      className="detail-page-container"
    >
      <div className="detail-bg-overlay" style={{backgroundImage: `url(${heroImg || product.image})`}}></div>

      <div className="detail-content">
        <button className="back-btn-large" onClick={() => history.goBack()}>← BACK TO BROWSE</button>

        <div className="detail-hero-section">
          
          <motion.div 
            initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ delay: 0.2 }}
            className="detail-image-frame"
          >
            {heroImg ? (
              <img 
                src={heroImg} 
                alt={product.name} 
                onError={handleHeroError} 
                referrerPolicy="no-referrer" 
                crossOrigin="anonymous"
              />
            ) : (
              <div style={{width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', color:'#555'}}>NO IMAGE</div>
            )}
          </motion.div>

          <h1 className="detail-main-title">{product.name}</h1>
          
          <div className="detail-sku-section">
             <span className="label-large">AVATAR ID (SKU)</span>
             <div className="sku-display">
                <code>{product.sku}</code>
                <button className={`copy-btn-large ${copied ? 'copied' : ''}`} onClick={handleCopy}>
                  {copied ? 'COPIED!' : 'COPY ID'}
                </button>
             </div>
          </div>

          <div className="detail-info-grid">
            
            {/* --- PRICE BLOCK --- */}
            <div className="info-block">
              <span className="info-label">PRICE</span>
              <span className="info-value" style={{color:'var(--blood-red)'}}>{product.price || 'N/A'}</span>
            </div>

            <div className="info-block">
              <span className="info-label">TITLE ID</span>
              <span className="info-value">{product.titleId}</span>
            </div>

            <div className="info-block">
              <span className="info-label">REGION</span>
              <span className="info-value region-value">
                {raw.region} <span style={{opacity:0.6}}>({raw.group})</span>
              </span>
            </div>

            <div className="info-block">
              <span className="info-label">PUBLISHER</span>
              <span className="info-value">{raw.publisher || 'N/A'}</span>
            </div>

            <div className="info-block full-width">
              <span className="info-label">RELEASE DATE</span>
              <span className="info-value">{raw.release_date ? raw.release_date.split('T')[0] : 'N/A'}</span>
            </div>

            <div className="info-block full-width">
              <span className="info-label">PLATFORMS</span>
              <div className="platform-tags">
                {raw.platforms ? raw.platforms.map(p => <span key={p} className="plat-tag">{p}</span>) : 'PSN'}
              </div>
            </div>

          </div>
        </div>
      </div>

      {relatedProducts.length > 0 && (
        <div className="related-section-container">
          <h3 className="related-title-large">MORE FROM THIS TITLE</h3>
          <div className="product-grid related-grid-override">
            {relatedProducts.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        </div>
      )}
    </motion.div>
  );
};

export default ProductDetail;